module.exports = "img/videos/14.bda1ed.mp4";